export const environment = {
  Xano: {
    Endpoint: 'https://cdn.rentalheroes.com.au',
    RealtimeToken: 'CmkYRYdjt7GH4i_iMHb51VfbpzI',
    Env: 'Staging',
  },
};
